import React, { useState } from 'react';

import Icon from 'dpl/common/components/Icon';
import { isMobileUA } from 'dpl/shared/utils';
import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import TooltipWrapper from 'dpl/common/tooltip/components/TooltipWrapper';
import { TOOLTIP_VARIANTS } from 'dpl/common/utils/constants';
import { isGreaterThanBreakpoint } from 'dpl/util/grid';

import StripeChargeModalFixedTooltipWrapper from './StripeChargeModalFixedTooltipWrapper';

const IS_GT_LG = isGreaterThanBreakpoint('lg');

export interface IconProps {
  name: string;
  renderFunction?: () => React.ReactNode;
  buttonId?: string;
  width?: string;
  height?: string;
}

export interface TooltipProps {
  title: React.ReactNode;
  className?: string;
  minWidth?: string;
  isVisible?: boolean;
}

export interface ModalProps {
  maxWidth?: string;
  content: React.ReactNode;
  isVisible?: boolean;
  onVisibilityChanged?: (isOpen: boolean) => void;
  closeButtonClassName?: string;
}

export interface DesktopTooltipProps {
  title: React.ReactNode;
}

interface StripeChargeModalIconRenderWrapperProps {
  tooltipProps?: TooltipProps | null;
  iconProps: IconProps;
  modalProps?: ModalProps | null;
  desktopTooltipProps?: DesktopTooltipProps | null;
}

export default function StripeChargeModalIconRenderWrapper({
  tooltipProps = null,
  iconProps,
  modalProps = null,
  desktopTooltipProps = null
}: StripeChargeModalIconRenderWrapperProps) {
  const isMobile = isMobileUA();
  const [isModalOpen, setModalOpen] = useState(false);

  if (!tooltipProps && !modalProps) {
    return <Icon {...iconProps} />;
  }

  function handleOpenness(isOpen: boolean) {
    modalProps?.onVisibilityChanged?.(isOpen) ?? setModalOpen(isOpen);
  }

  if (!isMobile && modalProps) {
    const displayModal = modalProps.isVisible ?? isModalOpen;
    return (
      <>
        {desktopTooltipProps && (IS_GT_LG || !modalProps.content) ? (
          <TooltipWrapper
            className="lh-0"
            variant={TOOLTIP_VARIANTS.STONE}
            title={desktopTooltipProps.title}
            minWidth="226px"
            disablePositionReset
          >
            <button
              type="button"
              id={iconProps.buttonId}
              data-test-id={iconProps.buttonId ?? 'line-item-button-icon'}
            >
              <Icon
                name={iconProps.name}
                width={iconProps.width}
                height={iconProps.height}
              />
            </button>
          </TooltipWrapper>
        ) : (
          <button
            type="button"
            id={iconProps.buttonId}
            data-test-id={iconProps.buttonId ?? 'line-item-button-icon'}
            onClick={() => handleOpenness(true)}
          >
            <Icon
              name={iconProps.name}
              width={iconProps.width}
              height={iconProps.height}
            />
          </button>
        )}
        {displayModal && (
          <MiniOverlayModal
            maxWidth={modalProps.maxWidth ?? '400px'}
            onCloseClick={() => handleOpenness(false)}
            closeButtonClassName={modalProps.closeButtonClassName}
          >
            <>{modalProps.content}</>
          </MiniOverlayModal>
        )}
      </>
    );
  }

  if (!tooltipProps) {
    return <Icon {...iconProps} />;
  }

  const title = tooltipProps.title ?? <></>;
  return (
    <StripeChargeModalFixedTooltipWrapper
      {...tooltipProps}
      // @ts-ignore
      title={title}
    >
      <Icon
        name={iconProps.name}
        width={iconProps.width}
        height={iconProps.height}
      />
    </StripeChargeModalFixedTooltipWrapper>
  );
}
